<div
  class="google-map"
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  *ngIf="agencyService.agency"
  (click)="this.isHidden = true;"
>
  <app-interface
    [travelModes]="travelModes"
    [isInfoHidden]="isHidden"
    (travelModeChanged)="changeTravelMode($event)"
  >
  </app-interface>
  <agm-map
    [scrollwheel]="false"
    [latitude]="latitude"
    [longitude]="longitude"
    [zoom]="15"
    [styles]="customStyle"
    (mapClick)="updateDirectionsPath($event)"
  >
    <gmaps-directions
      [color]="pathColor"
    >
    </gmaps-directions>
    <agm-marker
      [latitude]="latitude"
      [longitude]="longitude"
      (markerClick)="clickedMarker(latitude, longitude)"
      [iconUrl]="'/assets/icons/pins/logo-pin.png'"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="maps_click"
    >
    </agm-marker>
  </agm-map>
</div>



// WEBPACK FOOTER //
// ./src/app/localisation/gmap.component.html